export default __webpack_public_path__ + "static/media/icon-cross.b71a5d3d.svg";